import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserStore {
  phoneNumber: string | null;
  setPhoneNumber: (phone: string) => void;
  clearPhoneNumber: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    set => ({
      phoneNumber: null,
      setPhoneNumber: (phone: string) => set({ phoneNumber: phone }),
      clearPhoneNumber: () => set({ phoneNumber: null }),
    }),
    {
      name: 'user-storage',
    }
  )
);
